export function findNoneOptionValue(
  options: { value: string; label: string }[],
): string | null {
  const match = options.find(
    (opt) =>
      opt.value.trim().toLowerCase() === "none" ||
      opt.label.trim().toLowerCase() === "none",
  );
  return match?.value ?? null;
}

export function applyNoneExclusiveCheckboxChange(
  prev: string[],
  next: string[],
  noneValue: string | null,
): string[] {
  if (!noneValue) {
    return next;
  }

  const added = next.filter((v) => !prev.includes(v));
  const toggledOn = added[0];

  if (toggledOn === noneValue) {
    return [noneValue];
  }

  if (toggledOn && prev.includes(noneValue)) {
    return next.filter((v) => v !== noneValue);
  }

  return next;
}
